/*
 * How wide the Client Name picker is allowed to get, on every screen that has
 * one.
 *
 * Both pickers used to be sized by their Bootstrap column, which meant they
 * were sized by the browser window: the one on the analysis screen measured
 * 285px at a 1280px window, 325px at 1440px and 415px at 1800px, and the one
 * on the entry form was wider still. A client name is "Lastname, Firstname",
 * and the longest plausible one measures 216px, so the extra was room the
 * names never used.
 *
 * 329px rather than something name-sized because that is exactly how far the
 * Browse row runs on the entry form (UPLOAD_CONTROLS_WIDTH in upload.tsx), so
 * the picker and the row below it end on the same vertical line. The analysis
 * screen has nothing to line up with, and takes the same number so the two
 * pickers are the same control wherever a practitioner meets it.
 *
 * client-select-width.test.ts fails if the two drift apart.
 */
export const CLIENT_SELECT_MAX_WIDTH = 329;
